import swal from "sweetalert";
import successIcon from "./assets/success.png";
import errorIcon from "./assets/error.png";
import warningIcon2 from './assets/warning.png';

const iconMap = {
  success: successIcon,
  error: errorIcon,
  warning: warningIcon2,
  danger: warningIcon2,
};

const customSwal = ({
  title,
  description,
  badgeText,
  icon = "success",
  buttonText = "Delete",
  showCancel = false,
  cancelButtonText = "Cancel",
}) => {
  const wrapper = document.createElement("div");
  wrapper.className = "custom-swal";

  const badgeHtml = badgeText ? `<span class="custom-swal-badge">${badgeText}</span>` : '';
  const descriptionHtml = description ? `<p class="custom-swal-desc">${description}</p>` : '';

  wrapper.innerHTML = `
    <div class="custom-swal-header">
      <button class="custom-swal-close"><span>×</span></button>
    </div>

    <h6 class="custom-swal-title"> <img src="${iconMap[icon]}" class="custom-swal-icon" /> ${title}</h6>
    ${descriptionHtml}
    ${badgeHtml}
  `;

  const closeBtn = wrapper.querySelector(".custom-swal-close");
  closeBtn.onclick = () => swal.close();

  const buttons = {
    confirm: {
      text: buttonText,
      className: `btn-custom-${icon}`,
    },
  };
  if (showCancel) {
    buttons.cancel = {
      text: cancelButtonText,
      visible: true,
      className: "btn-custom-cancel",
    };
  }

  return swal({
    content: wrapper,
    className: "my-custom-swal-parent",
    buttons,
    closeOnClickOutside: false,
    closeOnEsc: true,
  });
};

export default customSwal;
